import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ClockFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM8.71429 4C8.71429 3.60551 8.39449 3.28571 8 3.28571C7.60551 3.28571 7.28571 3.60551 7.28571 4V8C7.28571 8.39449 7.60551 8.71429 8 8.71429H10.8571C11.2516 8.71429 11.5714 8.39449 11.5714 8C11.5714 7.60551 11.2516 7.28571 10.8571 7.28571H8.71429V4Z"
      fill="currentColor"
    />
  </svg>
);
